/**
 * @generated SignedSource<<25d2fdfce7cf8d78726c65ce0eb6cf8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TodoState = "CHECKED" | "DISMISSED" | "UNCHECKED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TodoOptionsMenu_todo$data = {
  readonly assignee: {
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "UserHandle_member">;
  } | null;
  readonly canDelete: {
    readonly value: boolean;
  };
  readonly canTransition: {
    readonly value: boolean;
  };
  readonly dueDate: DateString  | null;
  readonly id: string;
  readonly state: TodoState;
  readonly " $fragmentSpreads": FragmentRefs<"AssignTodoModal_todo" | "TodoDueDateModal_todo">;
  readonly " $fragmentType": "TodoOptionsMenu_todo";
};
export type TodoOptionsMenu_todo$key = {
  readonly " $data"?: TodoOptionsMenu_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOptionsMenu_todo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOptionsMenu_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssignTodoModal_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDueDateModal_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canTransition",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canDelete",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserHandle_member"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatar_member"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueDate",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "82f30c7498bb70df07e275a69cb832d0";

export default node;
